module.exports = __webpack_public_path__ + "static/FS-Barrier-1-2-33e108b09dd1e1dfccd827651e172766.png";